import React from 'react'
import styles from './iconText.module.scss'

export default ({ children, icon = null }) => (
  <p className={styles.iconText}>
    {icon && <span className={styles['iconText__icon']}>{icon}</span>}
    {children}
  </p>
)
